import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";

const propTypes = {
  floated: PropTypes.oneOf(["left", "right"]),
  buttonText: PropTypes.string,
  linkTo: PropTypes.string,
  circular: PropTypes.bool
};

function BotonCerrar(props) {
  return (
    <Link to={props.linkTo}>
      <Button
        icon="close"
        circular={props.circular}
        color="pink"
        floated={props.floated}
        content={props.buttonText}
      />
    </Link>
  );
}

BotonCerrar.defaultProps = {
  floated: "left",
  buttonText: "Cerrar",
  linkTo: "/inicio",
  circular: false
};

BotonCerrar.propTypes = propTypes;

export default BotonCerrar;



// WEBPACK FOOTER //
// ./src/pages/shared/botones/BotonCerrar.jsx